import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "superuser-fbg-chance-configs flex flex-column p3" }
const _hoisted_2 = { class: "mb2 flex" }
const _hoisted_3 = { class: "mr2" }
const _hoisted_4 = { class: "mr2" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = {
  key: 0,
  class: "superuser-fbg-chance-configs__edit ml2"
}
const _hoisted_8 = { class: "edit__header flex justify-between items-center mb2" }
const _hoisted_9 = { class: "edit__header-title" }
const _hoisted_10 = {
  key: 0,
  class: "edit__wrapper p2"
}
const _hoisted_11 = {
  key: 0,
  class: "edit__item py1 flex items-center"
}
const _hoisted_12 = { class: "label mr3" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "edit__item py1 items-center" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "label mr3" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "label mr3" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "edit__item py1 flex items-center" }
const _hoisted_22 = { class: "label mr3" }
const _hoisted_23 = { class: "value" }
const _hoisted_24 = {
  key: 1,
  class: "edit__item py1 flex items-center"
}
const _hoisted_25 = { class: "label mr3" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "input-wrapper" }
const _hoisted_28 = { class: "flex items-center" }
const _hoisted_29 = { class: "mr1" }
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "pi pi-question-circle mb1" }, null, -1)
const _hoisted_31 = {
  key: 2,
  class: "edit__item py1 flex items-center"
}
const _hoisted_32 = { class: "label mr3" }
const _hoisted_33 = { class: "value flex flex-column" }
const _hoisted_34 = { class: "p-field flex flex-column mt1" }
const _hoisted_35 = { class: "flex items-center" }
const _hoisted_36 = { class: "mr1" }
const _hoisted_37 = /*#__PURE__*/_createVNode("i", { class: "pi pi-question-circle mb1" }, null, -1)
const _hoisted_38 = { class: "p-field flex flex-column mt1" }
const _hoisted_39 = { class: "flex items-center" }
const _hoisted_40 = { class: "mr1" }
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "pi pi-question-circle mb1" }, null, -1)
const _hoisted_42 = { class: "p-field flex flex-column mt1" }
const _hoisted_43 = { class: "flex items-center" }
const _hoisted_44 = { class: "mr1" }
const _hoisted_45 = /*#__PURE__*/_createVNode("i", { class: "pi pi-question-circle mb1" }, null, -1)
const _hoisted_46 = {
  key: 3,
  class: "edit__item py1 flex items-center"
}
const _hoisted_47 = { class: "label mr3" }
const _hoisted_48 = { class: "value flex flex-column" }
const _hoisted_49 = { class: "p-field flex flex-column mt1" }
const _hoisted_50 = { class: "flex items-center" }
const _hoisted_51 = { class: "mr1" }
const _hoisted_52 = /*#__PURE__*/_createVNode("i", { class: "pi pi-question-circle mb1" }, null, -1)
const _hoisted_53 = { class: "p-field flex flex-column mt1" }
const _hoisted_54 = { class: "flex items-center" }
const _hoisted_55 = { class: "mr1" }
const _hoisted_56 = /*#__PURE__*/_createVNode("i", { class: "pi pi-question-circle mb1" }, null, -1)
const _hoisted_57 = { class: "p-field flex flex-column mt1" }
const _hoisted_58 = { class: "flex items-center" }
const _hoisted_59 = { class: "mr1" }
const _hoisted_60 = /*#__PURE__*/_createVNode("i", { class: "pi pi-question-circle mb1" }, null, -1)
const _hoisted_61 = {
  key: 4,
  class: "edit__item"
}
const _hoisted_62 = { class: "superuser-fbg-chance-configs__preview p4 mt3 center" }
const _hoisted_63 = { class: "h2 mb2" }
const _hoisted_64 = {
  key: 5,
  class: "edit__item"
}
const _hoisted_65 = { class: "superuser-fbg-chance-configs__preview p4 mt3 center" }
const _hoisted_66 = { class: "h2 mb2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_DropdownSelect = _resolveComponent("DropdownSelect")!
  const _component_BaseTooltipWrapper = _resolveComponent("BaseTooltipWrapper")!
  const _component_Input = _resolveComponent("Input")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: "mb2",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewChanceConfig && _ctx.addNewChanceConfig(...args)))
    }, "New Chance Config (GOD MODE changing)"),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.configs, (config, configIndex) => {
      return (_openBlock(), _createBlock("div", {
        class: "mb4",
        key: config.id
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("b", _hoisted_3, _toDisplayString(config.id), 1),
          _createVNode("div", _hoisted_4, _toDisplayString(config.cards.length) + " cards", 1),
          _createVNode(_component_Button, {
            onClick: ($event: any) => (_ctx.addNew(configIndex))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.addNew')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_DataTable, {
            class: "superuser-fbg-chance-configs__all",
            value: config.cards,
            responsiveLayout: "scroll"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "id",
                header: "ID"
              }),
              _createVNode(_component_Column, {
                field: "descriptionEn",
                header: "Description English"
              }),
              _createVNode(_component_Column, {
                field: "descriptionPl",
                header: "Description Polish"
              }),
              _createVNode(_component_Column, {
                field: "actions",
                header: "Actions"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("i", {
                      class: "pi pi-pencil mx1",
                      onClick: ($event: any) => (_ctx.editCard(slotProps.data.id, configIndex))
                    }, null, 8, ["onClick"]),
                    _createVNode("i", {
                      class: "pi pi-trash mx1",
                      onClick: ($event: any) => (_ctx.deleteChanceCard(slotProps.data.id, configIndex, config.id))
                    }, null, 8, ["onClick"])
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["value"]),
          (_ctx.chanceCardsChangedActiveIndex === configIndex)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.editor')), 1),
                  _createVNode(_component_Button, {
                    class: "ml1",
                    onClick: ($event: any) => (_ctx.handleSaveChanceCards(configIndex, config.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.saveCard')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                (_ctx.cardEdited)
                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                      (_ctx.cardEdited.id)
                        ? (_openBlock(), _createBlock("div", _hoisted_11, [
                            _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.id')), 1),
                            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.cardEdited.id), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_14, [
                        _createVNode("div", _hoisted_15, [
                          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.descriptionEn')), 1),
                          _createVNode("div", _hoisted_17, [
                            _createVNode(_component_Textarea, {
                              placeholder: 
                      _ctx.$t('adminPanel.businessGame.chanceCards.descriptionEnPlaceholder')
                    ,
                              modelValue: _ctx.cardEdited.descriptionEn,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.cardEdited.descriptionEn = $event)),
                              rows: "7"
                            }, null, 8, ["placeholder", "modelValue"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_18, [
                          _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.descriptionPl')), 1),
                          _createVNode("div", _hoisted_20, [
                            _createVNode(_component_Textarea, {
                              placeholder: 
                      _ctx.$t('adminPanel.businessGame.chanceCards.descriptionPlPlaceholder')
                    ,
                              modelValue: _ctx.cardEdited.descriptionPl,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.cardEdited.descriptionPl = $event)),
                              rows: "7"
                            }, null, 8, ["placeholder", "modelValue"])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_21, [
                        _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.action')), 1),
                        _createVNode("div", _hoisted_23, [
                          _createVNode(_component_DropdownSelect, {
                            "model-value": _ctx.cardEdited.method,
                            options: _ctx.methodOptions,
                            "option-label": "label",
                            "option-value": "value",
                            onChange: ($event: any) => (_ctx.changeCardEditedMethod($event.value, configIndex))
                          }, null, 8, ["model-value", "options", "onChange"])
                        ])
                      ]),
                      (_ctx.cardEdited.method && _ctx.whatToShowConfig[_ctx.cardEdited.method] === 'number')
                        ? (_openBlock(), _createBlock("div", _hoisted_24, [
                            _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.config')), 1),
                            _createVNode("div", _hoisted_26, [
                              _createVNode("div", _hoisted_27, [
                                _createVNode("div", _hoisted_28, [
                                  _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.moneyValue')), 1),
                                  _createVNode(_component_BaseTooltipWrapper, {
                                    tooltip: _ctx.$t('adminPanel.businessGame.chanceCards.tooltips.moneyValue')
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_30
                                    ]),
                                    _: 1
                                  }, 8, ["tooltip"])
                                ]),
                                _createVNode(_component_Input, {
                                  modelValue: _ctx.cardEdited.payload,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.cardEdited.payload = $event))
                                }, null, 8, ["modelValue"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                _ctx.cardEdited.method &&
                _ctx.cardEdited.payload &&
                _ctx.whatToShowConfig[_ctx.cardEdited.method] === 'conditions'
              )
                        ? (_openBlock(), _createBlock("div", _hoisted_31, [
                            _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.config')), 1),
                            _createVNode("div", _hoisted_33, [
                              _createVNode("span", _hoisted_34, [
                                _createVNode("div", _hoisted_35, [
                                  _createVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.type')), 1),
                                  _createVNode(_component_BaseTooltipWrapper, {
                                    tooltip: _ctx.$t('adminPanel.businessGame.chanceCards.tooltips.type')
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_37
                                    ]),
                                    _: 1
                                  }, 8, ["tooltip"])
                                ]),
                                _createVNode(_component_DropdownSelect, {
                                  modelValue: _ctx.cardEdited.payload.type,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.cardEdited.payload.type = $event)),
                                  options: _ctx.typeOptions,
                                  "option-label": "label",
                                  "option-value": "value"
                                }, null, 8, ["modelValue", "options"])
                              ]),
                              _createVNode("span", _hoisted_38, [
                                _createVNode("div", _hoisted_39, [
                                  _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.conditionValue')), 1),
                                  _createVNode(_component_BaseTooltipWrapper, {
                                    tooltip: _ctx.$t('adminPanel.businessGame.chanceCards.tooltips.conditionValue')
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_41
                                    ]),
                                    _: 1
                                  }, 8, ["tooltip"])
                                ]),
                                _createVNode(_component_Input, {
                                  modelValue: _ctx.cardEdited.payload.value,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.cardEdited.payload.value = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _createVNode("span", _hoisted_42, [
                                _createVNode("div", _hoisted_43, [
                                  _createVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.moneyValue')), 1),
                                  _createVNode(_component_BaseTooltipWrapper, {
                                    tooltip: 
                        _ctx.$t('adminPanel.businessGame.chanceCards.tooltips.moneyValueIfCondition')
                      
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_45
                                    ]),
                                    _: 1
                                  }, 8, ["tooltip"])
                                ]),
                                _createVNode(_component_Input, {
                                  modelValue: _ctx.cardEdited.payload.money,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.cardEdited.payload.money = $event))
                                }, null, 8, ["modelValue"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                _ctx.cardEdited.method &&
                _ctx.cardEdited.payload &&
                _ctx.whatToShowConfig[_ctx.cardEdited.method] === 'fromToMax'
              )
                        ? (_openBlock(), _createBlock("div", _hoisted_46, [
                            _createVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.config')), 1),
                            _createVNode("div", _hoisted_48, [
                              _createVNode("span", _hoisted_49, [
                                _createVNode("div", _hoisted_50, [
                                  _createVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.from')), 1),
                                  _createVNode(_component_BaseTooltipWrapper, {
                                    tooltip: _ctx.$t('adminPanel.businessGame.chanceCards.tooltips.from')
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_52
                                    ]),
                                    _: 1
                                  }, 8, ["tooltip"])
                                ]),
                                _createVNode(_component_DropdownSelect, {
                                  modelValue: _ctx.cardEdited.payload.from,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.cardEdited.payload.from = $event)),
                                  options: _ctx.fromToOptions,
                                  "option-label": "label",
                                  "option-value": "value"
                                }, null, 8, ["modelValue", "options"])
                              ]),
                              _createVNode("span", _hoisted_53, [
                                _createVNode("div", _hoisted_54, [
                                  _createVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.to')), 1),
                                  _createVNode(_component_BaseTooltipWrapper, {
                                    tooltip: _ctx.$t('adminPanel.businessGame.chanceCards.tooltips.to')
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_56
                                    ]),
                                    _: 1
                                  }, 8, ["tooltip"])
                                ]),
                                _createVNode(_component_DropdownSelect, {
                                  modelValue: _ctx.cardEdited.payload.to,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.cardEdited.payload.to = $event)),
                                  options: _ctx.fromToOptions,
                                  "option-label": "label",
                                  "option-value": "value"
                                }, null, 8, ["modelValue", "options"])
                              ]),
                              _createVNode("span", _hoisted_57, [
                                _createVNode("div", _hoisted_58, [
                                  _createVNode("label", _hoisted_59, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.max')), 1),
                                  _createVNode(_component_BaseTooltipWrapper, {
                                    tooltip: _ctx.$t('adminPanel.businessGame.chanceCards.tooltips.max')
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_60
                                    ]),
                                    _: 1
                                  }, 8, ["tooltip"])
                                ]),
                                _createVNode(_component_Input, {
                                  modelValue: _ctx.cardEdited.payload.max,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.cardEdited.payload.max = $event))
                                }, null, 8, ["modelValue"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.cardEdited && _ctx.cardEdited.descriptionEn)
                        ? (_openBlock(), _createBlock("div", _hoisted_61, [
                            _createVNode("div", _hoisted_62, [
                              _createVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.chance')), 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.cardEdited.descriptionEn), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.cardEdited && _ctx.cardEdited.descriptionPl)
                        ? (_openBlock(), _createBlock("div", _hoisted_64, [
                            _createVNode("div", _hoisted_65, [
                              _createVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('adminPanel.businessGame.chanceCards.chance')), 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.cardEdited.descriptionPl), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}